import { array } from 'fp-ts';
import { pipe } from 'fp-ts/function';
import { Fragment } from 'react';
import { intersperse } from '@mews/fp';
import { AccountType, BillState, PaymentTableRecord } from '@mews-commander/data-access';
import { Typography } from '@optimus-web/core';
import { WithAccountId } from '@mews-commander/types';
import { Dash, EnterpriseLink, SpacedComma } from '@mews-commander/ui';
import {
    BillDetailEnterpriseLink,
    CompanyBillingEnterpriseLink,
    CustomerBillingEnterpriseLink,
} from '../../common/BillingEnterpriseLinks';
import { isFailedOrPendingStatus } from './utils';

export const PaymentsTableBillCell = ({ accountId, payment }: { payment: PaymentTableRecord } & WithAccountId) => {
    const { billName, billId, billState, state, linkedInvoices, billOwnerAccountType } = payment;

    const hasMultipleInvoices = linkedInvoices && linkedInvoices.length > 0;

    if ((state && isFailedOrPendingStatus(state)) || !billId || !billState || !billOwnerAccountType) {
        return <Dash />;
    }

    if (hasMultipleInvoices) {
        return (
            <Typography textStyle="bodyMediumStrong" as="div">
                {pipe(
                    linkedInvoices,
                    array.mapWithIndex((index, linkedInvoice) => (
                        <EnterpriseLink
                            key={linkedInvoice.id}
                            variant="basic"
                            underline={false}
                            to="Bill/Detail/$id"
                            params={{ id: linkedInvoice.id }}
                        >
                            {linkedInvoice.number}
                        </EnterpriseLink>
                    )),
                    intersperse((index: number) => <Fragment key={index}>{SpacedComma}</Fragment>)
                )}
            </Typography>
        );
    }

    if (billState === BillState.Closed) {
        return (
            <BillDetailEnterpriseLink accountId={accountId} billId={billId}>
                {billName}
            </BillDetailEnterpriseLink>
        );
    }

    const AccountBillingLink =
        billOwnerAccountType === AccountType.Company ? CompanyBillingEnterpriseLink : CustomerBillingEnterpriseLink;
    return (
        <AccountBillingLink accountId={accountId} billId={billId}>
            {billName}
        </AccountBillingLink>
    );
};
